export default "__VITE_ASSET__f3ebeca2__"